import React, { useState } from 'react'
import _ from 'lodash'

import { Button, Divider } from '@material-ui/core'
import { formatBRL, formatToCurrency } from 'utils/functions'
import { ArrowDropDown, ArrowRight } from '@material-ui/icons'
import colors from 'utils/constants/colors'

import Container from '../styles'
import NoDataFoundMessage from '../../NoDataFoundMessage'
import { sectionNames, sectionsMetadata } from './sectionsInfo'

const MonthlyTable = ({ title, data, columns }) => {
  if (_.isEmpty(data)) return null

  const totalCellColor = (col) => {
    const totalItem = data.total?.[col.key]
    if (!totalItem) return null

    return totalItem.valid ? null : colors.red
  }

  const renderCell = (col, value) =>
    col.format === 'currency' ? formatToCurrency(value) : value ?? '-'

  const renderTotalCell = (col, value) =>
    col.format === 'currency' ? formatBRL(value) : value ?? '-'

  return (
    <div style={{ marginTop: '24px' }}>
      <h4>{title}</h4>
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Mês</th>
              {columns.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sectionsMetadata.months.map((month) => (
              <tr key={month.key}>
                <td>{month.label}</td>
                {columns.map((col) => (
                  <td key={col.key}>{renderCell(col, data[month.key]?.[col.key])}</td>
                ))}
              </tr>
            ))}
            <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
              <td>Total</td>
              {columns.map((col) => (
                <td key={col.key}>
                  <span style={{ color: totalCellColor(col) }}>
                    {renderTotalCell(col, data.total?.[col.key]?.amount)}
                  </span>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

const IncomeFromIndividual = ({ irDeclaration, sectionId, isExportingPDF }) => {
  const [showList, setShowList] = useState(false)
  const sectionData = _.get(irDeclaration, sectionId)

  const renderHolderData = () => {
    const items = sectionData?.items
    if (_.isEmpty(items)) return null

    return _.map(_.sortBy(items, (i) => i.page), (item) => (
      <div
        key={item.page}
        className="values-file-container"
        style={{ marginBottom: '24px' }}
      >
        <div className="text-container">
          {item.dependent_cpf && (
            <p>
              <strong>CPF do Dependente:</strong>
              {' '}
              {item.dependent_cpf}
            </p>
          )}
          {item.nit_pis_pasep && (
            <p>
              <strong>NIT/PIS/PASEP:</strong>
              {' '}
              {item.nit_pis_pasep}
            </p>
          )}
          {item.page && (
            <p>
              <strong>Página:</strong>
              {' '}
              {item.page}
            </p>
          )}
        </div>

        <MonthlyTable
          title="Rendimentos"
          data={item.income}
          columns={sectionsMetadata.incomeColumns}
        />
        <MonthlyTable
          title="Deduções"
          data={item.deductions}
          columns={sectionsMetadata.deductionsColumns}
        />
        <MonthlyTable
          title="Carnê-Leão"
          data={item.lion_carnet}
          columns={sectionsMetadata.lionCarnetColumns}
        />
        <Divider />
      </div>
    ))
  }
  return (
    <Container>
      <h2>{sectionData?.section_name || sectionNames[sectionId]}</h2>
      {_.isEmpty(sectionData) || _.isEmpty(sectionData.items) ? (
        <NoDataFoundMessage />
      ) : (
        <div>
          <div className="values-files-container">
            <Button
              startIcon={showList ? <ArrowDropDown /> : <ArrowRight />}
              onClick={() => setShowList(!showList)}
            >
              <strong style={{ fontSize: '1.34rem' }}>
                {showList ? 'Esconder itens' : 'Exibir itens'}
              </strong>
            </Button>
            {(showList || isExportingPDF) && <div style={{ marginTop: '24px' }}>{renderHolderData()}</div>}
          </div>
        </div>
      )}
    </Container>
  )
}

export default IncomeFromIndividual
